import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import dayjs from 'dayjs';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TMonthYearPickerPopoverProps } from '@/shared/components/ui/month-year-select/month-year-picker-popover.types';
import { PopoverController } from '@/shared/components/ui/popover/components/popover-controller/popover-controller';

export const MonthYearPickerPopover: React.FC<TMonthYearPickerPopoverProps> = ({
  trigger,
  value,
  onChange,
  onAccept,
  disabled,
  actionBarActions = ['cancel', 'accept'],
  datePickerProps,
  timezone = 'UTC',
  ...popoverProps
}) => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language.split('-')[0];

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
      <PopoverController trigger={trigger} {...popoverProps}>
        {(handleClose) => (
          <StaticDatePicker
            {...datePickerProps}
            disabled={disabled}
            // Defaults to UTC so the picked month is stable regardless of the
            // viewer's timezone. The value emitted by onChange stays in this
            // timezone, so callers read the month the user actually clicked.
            timezone={timezone}
            value={value}
            onChange={(newValue) =>
              onChange(dayjs.isDayjs(newValue) ? newValue : null)
            }
            views={['year', 'month']}
            openTo="month"
            localeText={{ toolbarTitle: t('ui:select_month_year') }}
            slotProps={{
              actionBar: { actions: actionBarActions },
            }}
            onAccept={() => {
              onAccept?.();
              handleClose();
            }}
            onClose={handleClose}
          />
        )}
      </PopoverController>
    </LocalizationProvider>
  );
};
